const location = `${process.env.PUBLIC_URL}/api`;

//
// Requests performed at the beginning
//

// Chiedi l'intera lista dei piatti
let getPiatti = async () => {
    const url = '/piatti';
    const response = await fetch(location+url);
    try{
        const jsonRes = await response.json();
        if(response.ok){
            return jsonRes;
        }else{
            let err = {status: response.status, ...jsonRes};
            throw err;
        }
    }catch (e) {
        let err = {status: response.status, ...e};
        throw err;
    }
}

// Chiedi l'intera lista delle categorie
let getCategorie = async () => {
    const url = '/categorie';
    const response = await fetch(location+url);
    try{
        const jsonRes = await response.json();
        if(response.ok){
            return jsonRes;
        }else{
            let err = {status: response.status, ...jsonRes};
            throw err;
        }
    }catch (e) {
        let err = {status: response.status, ...e};
        throw err;
    }
}

// Chiedi l'intera lista delle impostazioni
let getImpostazioni = async () => {
    const url = '/tag';
    const response = await fetch(location+url);
    try{
        const jsonRes = await response.json();
        if(response.ok){
            return jsonRes;
        }else{
            let err = {status: response.status, ...jsonRes};
            throw err;
        }
    }catch (e) {
        let err = {status: response.status, ...e};
        throw err;
    }
}

// Richiedi le fasce orarie
let getFasceOrarie = async () => {
    const url = '/fasce';
    const response = await fetch(location+url);
    try{
        const jsonRes = await response.json();
        if(response.ok){
            return jsonRes;
        }else{
            let err = {status: response.status, ...jsonRes};
            throw err;
        }
    }catch (e) {
        let err = {status: response.status, ...e};
        throw err;
    }
}

// Invia ordine
let inviaOrdine = async (dettagliOrdine) => {
    const url = '/ordine';
    const response = await fetch(location+url,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(dettagliOrdine)
    });

    try{
        const jsonRes = await response.json();
        if(response.ok){
            return jsonRes;
        }else{
            let err = {status: response.status, ...jsonRes};
            throw err;
        }
    }catch (e) {
        let err = {status: response.status, ...e};
        throw err;
    }
}

const Api = {getPiatti, getImpostazioni, getCategorie, getFasceOrarie, inviaOrdine};
export default Api;
